/** PostHog feature flag key for the Memory Map workspace route. */
export const MEMORY_MAP_POSTHOG_FLAG = 'memory_map' as const;
